function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import './if-dev.scss';
var IfDevComponentCtrl = /*#__PURE__*/function () {
  IfDevComponentCtrl.$inject = ["$log", "$element", "CandidatoCfg"];
  function IfDevComponentCtrl($log, $element, CandidatoCfg) {
    _classCallCheck(this, IfDevComponentCtrl);
    this.$log = $log;
    this.$element = $element;
    this.CandidatoCfg = CandidatoCfg;
  }
  return _createClass(IfDevComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.show = this.toggle && this.CandidatoCfg.debugforce || this.CandidatoCfg.debug;
      this.show = this.CandidatoCfg.debugforce || this.CandidatoCfg.debug;
      this.$log.info('[IfDevComponentCtrl] onInit', this.show, this.clazz);
      if (this.clazz) {
        this.$element.addClass(this.clazz);
      }
      if (!this.show) this.$element.remove();
    }
  }]);
}();
angular.module('candidato').component('ifDev', {
  bindings: {
    // empresa: "<",
    toggle: '<',
    clazz: '@'
  },
  controllerAs: 'ctrl',
  transclude: true,
  controller: IfDevComponentCtrl,
  template: "<span class=\"if__dev\" ng-if=\"::ctrl.show\" ng-transclude></span>"
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/if-dev/if-dev.component.html"
});